import { CalendarOutlined } from '@ant-design/icons';
import { DatePicker, type DatePickerProps } from 'antd';

import dayjs from '@/utils/dayjs';
import { formatShortDateTime } from '@/utils/formatDate';

import type { Dayjs } from 'dayjs';

const pickerDisplayFormat = (value: Dayjs) => formatShortDateTime(value);

function range(start: number, end: number) {
  const result = [];
  for (let i = start; i < end; i++) {
    result.push(i);
  }
  return result;
}

const disabledDate = (current: Dayjs) =>
  !!current && current.isBefore(dayjs().subtract(1, 'day').endOf('day'));

const disabledTime = (current: Dayjs | null) => {
  const now = dayjs();
  if (current && current.isSame(now, 'day')) {
    return {
      disabledHours: () => range(0, 24).splice(0, now.hour()),
      disabledMinutes: () =>
        current.isSame(now, 'hour') && current.isSame(now, 'day')
          ? range(0, now.minute())
          : [],
    };
  }
  return {};
};

/** Date + time picker for scheduling (proposals, offers, invoices). */
const ScheduleDateTimePicker = ({ ...rest }: DatePickerProps) => (
  <DatePicker
    showTime={{ format: 'HH:mm', minuteStep: 15 }}
    showNow={false}
    placeholder=""
    suffixIcon={<CalendarOutlined />}
    disabledDate={disabledDate}
    disabledTime={disabledTime}
    format={pickerDisplayFormat}
    style={{ width: '100%' }}
    {...rest}
  />
);

export default ScheduleDateTimePicker;
